const topCntnts = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let secCntnts = document.querySelector('#jsSecCntnts');
    let pinWrap = secCntnts.querySelector('.js-pin-wrap');
    let pinArea = pinWrap.querySelector('.js-pin-area');
    let listBox2 = pinArea.querySelector('.js-list-box-2');
    let main = listBox2.querySelector('.js-img-main');
    let video = listBox2.querySelector('video');
    video.load()


    // ピン
    gsap.to('#jsSecCntnts .js-pin-wrap', {
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: '#jsSecCntnts .js-pin-wrap',
        start: '0% 0%',
        endTrigger: '#jsSecCntnts',
        end: '100% 100%',
        pin: true,
        pinSpacing: false,
        // markers: true,
      }
    });


    // パララックス
    gsap.set('#jsSecCntnts .js-pin-wrap .js-pin-area .js-list-box-1', {
      y: -100,
    });
    gsap.set('#jsSecCntnts .js-pin-wrap .js-pin-area .js-list-box-2', {
      y: 100,
    });
    gsap.set('#jsSecCntnts .js-pin-wrap .js-pin-area .js-list-box-3', {
      y: -100,
    });
    gsap.to('#jsSecCntnts .js-pin-wrap .js-pin-area .js-list-box-1', {
      y: 0,
      ease: "none",
      scrollTrigger: {
        trigger: '#jsSecCntnts .js-pin-wrap',
        start: '0% 100%',
        end: '0% 0%',
        scrub: 1,
        // markers: true,
      }
    });
    gsap.to('#jsSecCntnts .js-pin-wrap .js-pin-area .js-list-box-2', {
      y: 0,
      ease: "none",
      scrollTrigger: {
        trigger: '#jsSecCntnts .js-pin-wrap',
        start: '0% 100%',
        end: '0% 0%',
        scrub: 1,
        // markers: true,
      }
    });
    gsap.to('#jsSecCntnts .js-pin-wrap .js-pin-area .js-list-box-3', {
      y: 0,
      ease: "none",
      scrollTrigger: {
        trigger: '#jsSecCntnts .js-pin-wrap',
        start: '0% 100%',
        end: '0% 0%',
        scrub: 1,
        // markers: true,
      }
    });


    // ズーム
    gsap.to('#jsSecCntnts .js-pin-wrap .js-pin-area .js-img', {
      minWidth: '100vw',
      height: '100vh',
      ease: "none",
      scrollTrigger: {
        trigger: '#jsSecCntnts .js-zoom-wrap',
        start: '0% 100%',
        end: '0% 0%',
        scrub: 1,
        onEnter: () => main.classList.add('is-act'),
        // onLeave: () => console.log("onLeave"),
        // onEnterBack: () => console.log("onEnterBack"),
        onLeaveBack: () => main.classList.remove('is-act'),
        // markers: true,
      }
    });


    //コンテンツ
    ScrollTrigger.create({
      trigger: '#jsSecCntnts .js-cntnts-wrap',
      start: '0% 100%',
      endTrigger: 'body',
      end: '100% 0%',
      toggleClass: {
        targets: '#jsSecCntnts .js-pin-wrap .js-cntnts-area',
        className: "is-act"
      },
      // markers: true,
    });
    ScrollTrigger.create({
      trigger: '#jsSecCntnts .js-cntnts-wrap',
      start: '0% 100%',
      endTrigger: 'body',
      end: '100% 0%',
      toggleClass: {
        targets: '#jsSecCntnts .js-pin-wrap .js-pin-area',
        className: "is-act"
      },
      onEnter: () => {
        setTimeout(() => {
          video.play()
        }, 2000);
      },
      // onLeave: () => console.log("onLeave"),
      // onEnterBack: () => console.log("onEnterBack"),
      // onLeaveBack: () => console.log("onLeaveBack"),
      // markers: true,
    });



  }
})()
export default topCntnts;